import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 로컬 번역 파일 import
import koTranslation from './locales/ko/translation.json';
import enTranslation from './locales/en/translation.json';

// 번역 리소스
const resources = {
  ko: {
    translation: koTranslation
  },
  en: {
    translation: enTranslation
  }
};

// 지원하는 언어 목록
const supportedLanguages = [
  { code: 'ko', name: '한국어', nativeName: '한국어' },
  { code: 'en', name: 'English', nativeName: 'English' }
];

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    lng: localStorage.getItem('selectedLanguage') || 'ko',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

// 사용 가능한 언어 목록 가져오기
export const getAvailableLanguages = () => {
  return supportedLanguages;
};

// 언어 변경
export const changeLanguage = (langCode) => {
  localStorage.setItem('selectedLanguage', langCode);
  i18n.changeLanguage(langCode);
};

export default i18n;
